import { render, staticRenderFns } from "./v-wangEditor.vue?vue&type=template&id=89390a68&"
import script from "./v-wangEditor.vue?vue&type=script&lang=ts&"
export * from "./v-wangEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports